import React, { useContext, useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import DatePicker from "react-datepicker";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import BootstrapTable from "react-bootstrap-table-next";
import { reportingServices } from "../../../Services/AccountingServices/reporting.service";
import { AuthContext } from "../../../Contexts/AuthContext";
import { globalServices } from "../../../Services/global.service";
import { useHistory } from "react-router-dom";
import SpinnerLoading from "../../Common/SpinnerLoading";
import paginationFactory from "react-bootstrap-table2-paginator";
import { dateFormatter } from "../../../Helpers/DateHelper";
import moment from "moment";

const Recapitulation = () => {
  const { t: translator } = useTranslation();
  const { tenantId, userId, useAccounting } = useContext(AuthContext);
  const {
    selectedLanguageId,
    isMobile,
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
  } = useContext(GlobalContext);
  const history = useHistory();
  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "submit",
    reValidateMode: "onSubmit",
  });
  const [recType, setRecType] = useState({ columns: [{}] });
  const [stores, setStores] = useState([]);
  const [recapitulationData, setRecapitulationData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [filters, setFilters] = useState({
    tenantId: Number(tenantId),
    storeTag: null,
    productGuid: null,
    productGroups: null,
    documentTypeId: null,
    from: null,
    to: null,
  });

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    updateLocName("recapitulation");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
    if (Number(tenantId) > 0) {
      getStores(tenantId);
    }
  }, []);

  const getStores = (tenantId) => {
    globalServices.getStoresByTenantId(tenantId).then((res) => {
      setStores(res.data);
    });
  };

  const tenantPromiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));
        return result;
      })
      .catch((err) => err);
  };
  const exportExcelFunction = () => {
    recType.exportData(
      filters,
      `${recType.name}-${dateFormatter(filters.from)}-${dateFormatter(
        filters.to
      )}`
    );
  };

  const recapitulationTypes = {
    taxrate: {
      name: translator("RecapitulationType-TaxRate"),
      getData: reportingServices.getRecapitulationTaxrate,
      exportData: reportingServices.exportXLSXRecapitulationTaxrate,
      columns: [
        {
          dataField: "taxRateName",
          text: translator("Traffic-TableHeader-TaxRateName"),
          sort: true,
        },

        {
          dataField: "totalQuantityIn",
          text: translator("Traffic-TableHeader-TotalQuantityIn"),
          sort: true,
        },
        {
          dataField: "totalQuantityOut",
          text: translator("Traffic-TableHeader-TotalQuantityOut"),
          sort: true,
        },
        {
          dataField: "totalQuantityDiff",
          text: translator("Traffic-TableHeader-Diff"),
          sort: true,
        },
      ],
    },
    store: {
      name: translator("RecapitulationType-Store"),
      getData: reportingServices.getRecapitulationStore,
      exportData: reportingServices.exportXLSXRecapitulationStore,
      columns: [
        {
          dataField: "storeDescription",
          text: translator("Traffic-TableHeader-StoreDescription"),
          sort: true,
        },
        {
          dataField: "storeTag",
          text: translator("Traffic-TableHeader-StoreTag"),
          sort: true,
        },
        {
          dataField: "totalQuantityIn",
          text: translator("Traffic-TableHeader-TotalQuantityIn"),
          sort: true,
        },
        {
          dataField: "totalQuantityOut",
          text: translator("Traffic-TableHeader-TotalQuantityOut"),
          sort: true,
        },
        {
          dataField: "totalQuantityDiff",
          text: translator("Traffic-TableHeader-Diff"),
          sort: true,
        },
      ],
    },
    productGroup: {
      name: translator("RecapitulationType-ProductGroup"),
      getData: reportingServices.getRecapitulationProductGroup,
      exportData: reportingServices.exportXLSXRecapitulationProductGroup,
      columns: [
        {
          dataField: "productGroupName",
          text: translator("Traffic-TableHeader-ProductGroupName"),
          sort: true,
        },
        {
          dataField: "totalQuantityIn",
          text: translator("Traffic-TableHeader-TotalQuantityIn"),
          sort: true,
        },
        {
          dataField: "totalQuantityOut",
          text: translator("Traffic-TableHeader-TotalQuantityOut"),
          sort: true,
        },
        {
          dataField: "totalQuantityDiff",
          text: translator("Traffic-TableHeader-Diff"),
          sort: true,
        },
      ],
    },
    product: {
      name: translator("RecapitulationType-Product"),
      getData: reportingServices.getRecapitulationProduct,
      exportData: reportingServices.exportXLSXRecapitulationProduct,
      columns: [
        {
          dataField: "productName",
          text: translator("Traffic-TableHeader-ProductName"),
          sort: true,
        },
        {
          dataField: "productGroupName",
          text: translator("Traffic-TableHeader-ProductGroupName"),
          sort: true,
        },
        {
          dataField: "totalQuantityIn",
          text: translator("Traffic-TableHeader-TotalQuantityIn"),
          sort: true,
        },
        {
          dataField: "totalQuantityOut",
          text: translator("Traffic-TableHeader-TotalQuantityOut"),
          sort: true,
        },
        {
          dataField: "totalQuantityDiff",
          text: translator("Traffic-TableHeader-Diff"),
          sort: true,
        },
      ],
    },
    documentType: {
      name: translator("RecapitulationType-DocumentType"),
      getData: reportingServices.getRecapitulationDocumentType,
      exportData: reportingServices.exportXLSXRecapitulationDocumentType,
      columns: [
        {
          dataField: "documentTypeName",
          text: translator("Traffic-TableHeader-DocumentTypeName"),
          sort: true,
        },
        {
          dataField: "totalQuantityIn",
          text: translator("Traffic-TableHeader-TotalQuantityIn"),
          sort: true,
        },
        {
          dataField: "totalQuantityOut",
          text: translator("Traffic-TableHeader-TotalQuantityOut"),
          sort: true,
        },
        {
          dataField: "totalQuantityDiff",
          text: translator("Traffic-TableHeader-Diff"),
          sort: true,
        },
      ],
    },
  };

  const handleToSearch = (data) => {
    const m = moment();
    // set date tp
    let date = moment(data?.dateTo);
    m.set(date.toObject());
    const dateTo = m.endOf("day").format("YYYY-MM-DDTHH:mm:ss");
    // Set date from
    date = moment(data?.dateFrom);
    m.set(date.toObject());
    const dateFrom = m.startOf("day").format("YYYY-MM-DDTHH:mm:ss");

    const recType = data.recapitulationType.id;
    const searchFilters = {
      tenantId: data?.tenant?.id || Number(tenantId),
      storeTag: data?.store?.value || null,
      productGuid: null,
      productGroups: null,
      documentTypeId: null,
      from: dateFrom,
      to: dateTo,
    };
    setIsLoading(true);

    recapitulationTypes[recType]
      .getData(searchFilters)
      .then((res) => {
        setIsLoading(false);
        setRecapitulationData(res?.data?.data);
      })
      .catch((err) => console.log("Error while fetching traffic table. ", err));
  };

  const dateFromMaxDate = () => {
    const lastDay = new Date(new Date(filters.from).getFullYear(), 11, 31);
    return lastDay > new Date() ? new Date() : lastDay;
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Main-Sidebar-Recapitulation")}</span>
          {recapitulationData?.length > 0 && (
            <span className="badge badge-pill badge-primary ml-2">
              {recapitulationData.length}
            </span>
          )}
        </div>
        <div className="card-body">
          <fieldset className="scheduler-border">
            <form onSubmit={handleSubmit(handleToSearch)}>
              <div className="row">
                <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                  <label>{translator("Filters-RecapitulationType")}</label>

                  <Controller
                    as={Select}
                    control={control}
                    name="recapitulationType"
                    placeholder={translator("Select-RecapitulationType")}
                    rules={{
                      validate: function (value) {
                        if (!value) return false;
                        return value.value === 0 ? false : true;
                      },
                    }}
                    options={Object.keys(recapitulationTypes).map((key) => {
                      return {
                        id: key,
                        label: recapitulationTypes[key].name,
                        value: recapitulationTypes[key],
                      };
                    })}
                    onChange={(value) => {
                      setRecapitulationData(null);
                      setRecType(value[0].value);
                      return value[0];
                    }}
                  />
                  {errors.recapitulationType &&
                    errors.recapitulationType.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>
                {!(Number(tenantId) > 0) && (
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label> {translator("InvIssReport-Filters-Tenants")}</label>
                    <Controller
                      as={AsyncSelect}
                      control={control}
                      name="tenant"
                      defaultOptions={true}
                      loadOptions={tenantPromiseOptions}
                      placeholder={translator("Select-Tenant")}
                      onChange={(e) => {
                        setValue("store", null);
                        if (e[1].action == "clear") {
                          setFilters({ ...filters, tenantId: null });
                          setStores([]);
                          return null;
                        }
                        setFilters({ ...filters, tenantId: Number(e[0].id) });
                        getStores(e[0].id);
                        return e[0];
                      }}
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                    />
                    {errors.tenant && errors.tenant.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                )}
                <div className="form-group col-lg-3 col-md-4 col-xs-12">
                  <label htmlFor="ddlStore">
                    {translator("POS-New_EditPOS-Store")}
                  </label>{" "}
                  <Controller
                    as={<Select isClearable />}
                    disabled={!filters.tenantId}
                    options={
                      stores &&
                      stores.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.tag,
                      }))
                    }
                    name="store"
                    control={control}
                    placeholder={translator("Select-Store")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                  <label>{translator("Filters-DateFrom")}</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <img src={iconcontentcalendar} alt="calendar" />
                      </span>
                    </div>
                    <Controller
                      as={DatePicker}
                      control={control}
                      className="form-control"
                      autoComplete="off"
                      name="dateFrom"
                      valueName="selected"
                      rules={{ required: true }}
                      showYearDropdown={true}
                      dateFormat="dd.MM.yyyy"
                      locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                      onChange={function ([selected]) {
                        setFilters({ ...filters, from: selected, to: null });
                        setValue("dateTo", null);
                        return selected;
                      }}
                      maxDate={new Date()}
                    />
                  </div>
                  {errors.dateFrom && errors.dateFrom.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
                <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                  <label>{translator("Filters-DateTo")}</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <img src={iconcontentcalendar} alt="calendar" />
                      </span>
                    </div>
                    <Controller
                      as={DatePicker}
                      control={control}
                      className="form-control"
                      autoComplete="off"
                      name="dateTo"
                      valueName="selected"
                      rules={{ required: true }}
                      showYearDropdown={true}
                      dateFormat="dd.MM.yyyy"
                      locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                      onChange={function ([selected]) {
                        setFilters({ ...filters, to: selected });
                        return selected;
                      }}
                      disabled={!filters.from}
                      minDate={new Date(filters.from)}
                      maxDate={dateFromMaxDate()}
                    />
                  </div>
                  {errors.dateTo && errors.dateTo.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
              </div>
              <div className="row">
                <label>{""}</label>
                <div className="form-group">
                  <button
                    className="btn btn-primary pull-left ml-3 mt-2"
                    type="submit"
                  >
                    <span className="icon icon-search"></span>{" "}
                    {translator("InvIssReport-Btn-Search")}
                  </button>
                </div>
              </div>
            </form>
          </fieldset>
          {isLoading ? (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          ) : (
            recapitulationData && (
              <>
                <BootstrapTable
                  keyField="id"
                  data={recapitulationData}
                  columns={recType.columns}
                  rowClasses="bootstrap-table-row"
                  noDataIndication={translator("No-Data")}
                  pagination={paginationFactory({ hideSizePerPage: true })}
                />
                <button
                  className="btn btn-secondary pull-left  mt-2"
                  type="submit"
                  onClick={exportExcelFunction}
                >
                  {/* <span className="icon icon-search"></span>{" "} */}
                  {translator(".XLSX")}
                </button>
              </>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Recapitulation;
